module.exports = __webpack_public_path__ + "static/media/Barchart.0996fae2.svg";